<div class="flex flex-row space-x-2 align-items-start text-xl">
  <app-profile-picture [fitMedProfileId]="fitMedProfileId" [class]="'w-20 h-20'">
  </app-profile-picture>
  <div class="flex flex-col">
    <span class="truncate">{{ fullName }}</span>

    <div class="flex row text-sm">
      <app-gender [fitMedProfile]="fitMedProfile" [icon]="true" [name]="true">
      </app-gender>
      <span>{{", " + getAgeFromDOB(fitMedProfile.doB) }}</span>
    </div>

    <p class="text-sm">{{ fitMedProfile.doB | localizedDate }}</p>
  </div>
</div>
